import script from "./PartyAddNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartyAddNew.vue?vue&type=script&setup=true&lang=ts"

import "./PartyAddNew.vue?vue&type=style&index=0&id=6d87e0f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d87e0f2"]])

export default __exports__